<template>
  <div class="bg-white rounded-lg shadow-lg overflow-hidden transform hover:-translate-y-2 transition-transform duration-300 hover:bg-blue-200 flex flex-col">
    <img 
      :src="product.image"
      :alt="product.name"
      class="w-full h-48 object-contain"
    >
    <div class="p-6 flex flex-col flex-grow">
      <h3 class="text-xl font-semibold text-gray-800 mb-2">{{ product.name }}</h3>
      <p class="text-gray-600 mb-4 flex-grow">{{ product.shortDescription }}</p>
      <router-link 
        :to="`/products/${product.id}`"
        class="inline-block bg-blue-600 text-white px-4 py-2 rounded-md hover:bg-blue-700 transition-colors mt-auto self-start"
      >
        View Details
      </router-link>
    </div>
  </div>
</template>

<script setup>
defineProps({
  product: {
    type: Object,
    required: true
  }
})
</script>
